import { render, staticRenderFns } from "./create-bill.vue?vue&type=template&id=bd8baf12&scoped=true"
import script from "./create-bill.vue?vue&type=script&lang=ts"
export * from "./create-bill.vue?vue&type=script&lang=ts"
import style0 from "./create-bill.vue?vue&type=style&index=0&id=bd8baf12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8baf12",
  null
  
)

export default component.exports